import React from "react";
import { MoonLoader } from "react-spinners";
import Text from "../../../../../components/library/text";
import "./style.scss";

const Index = ({ title, description }) => {
  return (
    <div className="channel-details-view-loading-overlay">
      <div className="inner-loading-overlay">
        <div className="loader-container">
          <div className="loader">
            <MoonLoader size={40} color={"#4CA1F1"} loading={true} />
          </div>
          <h3 className="loading-title">{title}</h3>
          <Text align="center">{description}</Text>
        </div>
      </div>
    </div>
  );
};

export default Index;
